module.exports = __webpack_public_path__ + "static/img/maike.515f858.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/maike.png
// module id = XKYP
// module chunks = 1